/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Terms_HeadingInputs */

const ja_playdata_terms_heading = /** @type {(inputs: Playdata_Terms_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

const en_playdata_terms_heading = /** @type {(inputs: Playdata_Terms_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Playdata_Terms_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_terms_heading = /** @type {((inputs?: Playdata_Terms_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Terms_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_terms_heading(inputs)
	return en_playdata_terms_heading(inputs)
});